/*=========================================================================================
  File Name: index.js
  Namespace: files
  Description: Vuex Files Store
==========================================================================================*/

import actions from "./actions"

export default {
    namespaced: true,
    actions: actions
}